import { Component, Input, OnChanges, OnInit, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { Project } from '@src/app/models/project';
import { Meta } from '@angular/platform-browser';
import { Orgstyle } from '../../orgaccount/orgstyle/model/orgstyle';
import { UieventhubService } from '@src/app/helpers/uieventhub/uieventhub.service';
import { Task } from '@src/app/models/task';
import { DatastoreService } from '@src/app/helpers/datastore/datastore.service';
import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-portal',
  templateUrl: './portal.component.html',
  styleUrls: ['./portal.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PortalComponent implements OnInit {
  projectList: Project[];
  @Output() orgstyle: Orgstyle;
  @Output() userview: boolean = false;
  overdueTasks: Task[];
  dueTasks: Task[];
  upcomingTasks: Task[];
  doneTasks: Task[];
  private metaTagRefs: HTMLMetaElement[] = [];

  constructor(
    private router: Router,
    private uievent: UieventhubService,
    private meta: Meta,
    private datastore: DatastoreService
  ) {

  }

  ngOnInit() {
    this.uievent.portalView$.pipe(untilDestroyed(this)).subscribe(type => {
      if (type === "user") {
        this.userview = true;
      } else {
        this.userview = false;
      }
    });
    this.datastore.projectList$.pipe(untilDestroyed(this)).subscribe(list => {
      if (list) {
        this.projectList = list
      }

    });
    this.uievent.addLoader('portal');
    this.metaTagRefs = this.meta.addTags([
      { name: 'robots', content: 'noindex' },
      { name: 'googlebot', content: 'noindex' },
    ]);

    this.userview = SessionHelper.getUserview() == "true" ? true : false;
    if (SessionHelper.getCustomer()) {
      this.uievent.removeLoader('portal');
      this.router.navigate(['/customerportal'])
    }
    this.orgstyle = new Orgstyle;
    this.orgstyle.sidenav = 'top';
    if (SessionHelper.getDynamicStyle() && SessionHelper.getDynamicStyle() !== 'undefined') {
      this.orgstyle = JSON.parse(SessionHelper.getDynamicStyle());
    }

  }
  ngOnDestroy(): void {
    this.metaTagRefs.forEach(tag => this.meta.removeTagElement(tag));
  }
  userviewToggle() {
    this.userview = !this.userview;
  }

}
